import React, { useState } from "react";
import { connect } from "react-redux";
import CSSModules from "react-css-modules";
import TextArea from "components/Global-2016/Forms/TextArea";
import FieldGroupSettings from "components/Global/Table3/ModalColumn/FieldGroupSettings";
import Options from "./Options";
import css from "./style.scss";
import { actions, getters } from "../model";
import {
  getErrorMessage,
  getShowMaxLength,
  getCurrentForm
} from "../selectors";
import { Div, DeleteIcon, Text2 } from "components/Base";

const decorate = connect(
  (state, props) => {
    const form = getCurrentForm(state, props);
    return {
      error: getErrorMessage(state, props),
      showMaxLength: getShowMaxLength(state, props),
      forms: getters.forms(state, props),
      // Form specific fields
      type: form.type,
      name: form.name,
      description: form.description,
      fieldGroup: form.fieldGroup,
      maxLength: form.maxLength
    };
  },
  {
    updateFormField: actions.updateFormField,
    handleSave: actions.handleSave,
    removeForm: actions.removeForm
  }
);

const FormContent = props => {
  // Add state to track which fields have been touched
  const [touchedFields, setTouchedFields] = useState({
    name: false
  });

  // Helper function to mark a field as touched
  const markFieldAsTouched = fieldName => {
    setTouchedFields(prev => ({
      ...prev,
      [fieldName]: true
    }));
  };

  const {
    // Form fields
    type,
    name,
    description,
    fieldGroup,
    maxLength,
    moduleId,
    // UI state
    error,
    showMaxLength,
    // Form metadata
    formIndex,
    // Actions
    removeForm,
    updateFormField,
    // Form options
    forms,
    fieldTypes,
    fieldGroups
  } = props;

  // Show error only if the column name field has been touched
  const shouldShowError = error && touchedFields.name;

  return (
    <>
      <div styleName="modalBodyWrapper">
        {/* field name */}
        <div className="input-wrapper">
          <label styleName="formLabel">Field Name</label>
          <input
            autoFocus
            key="name"
            styleName="input"
            type="text"
            value={name}
            placeholder="Field Name"
            required
            onChange={ev =>
              updateFormField({
                index: formIndex,
                field: "name",
                value: ev.target.value
              })
            }
            onBlur={() => markFieldAsTouched("name")}
          />
        </div>

        {/* field type */}
        <div className="input-wrapper">
          <label styleName="formLabel">Field Type</label>
          <select
            key="type"
            styleName="select"
            onChange={ev =>
              updateFormField({
                index: formIndex,
                field: "type",
                value: ev.target.value
              })
            }
            defaultValue={type}
          >
            {fieldTypes
              .sort((a, b) => a.name.localeCompare(b.name))
              .map(item => (
                <option value={item.id} key={item.id}>
                  {item.name}
                </option>
              ))}
          </select>
        </div>

        <div className="input-wrapper">
          <label styleName="formLabel">Field Description</label>
          <TextArea
            onChange={ev =>
              updateFormField({
                index: formIndex,
                field: "description",
                value: ev.target.value
              })
            }
            placeholder="Description of field..."
            rows={2}
            value={description}
          />
        </div>

        <FieldGroupSettings
          onChange={ev =>
            updateFormField({
              index: formIndex,
              field: "fieldGroup",
              value: ev.target.value
            })
          }
          fieldGroups={fieldGroups}
          value={fieldGroup}
        />

        {/* field options */}
        <Options formIndex={formIndex} moduleId={moduleId} />

        {showMaxLength && (
          <div className="input-wrapper">
            <label styleName="formLabel">Maximum Length</label>
            <input
              styleName="input"
              type="number"
              value={maxLength}
              onChange={ev =>
                updateFormField({
                  index: formIndex,
                  field: "maxLength",
                  value: ev.target.value
                })
              }
            />
          </div>
        )}

        {/* error */}
        {shouldShowError ? <div styleName="error">{error}</div> : ""}

        {/* actions */}
        {forms.length > 1 && (
          <Div
            styleName="actionCancel"
            onClick={() => removeForm({ index: formIndex })}
            role="button"
            tabIndex="0"
            width={1}
            height={50}
            display="flex.row.center"
            gap={2}
          >
            <Text2 color="neutral5">Remove</Text2>
            <DeleteIcon color="red4" />
          </Div>
        )}
      </div>
    </>
  );
};

export default decorate(CSSModules(FormContent, css));
